export default __webpack_public_path__ + "static/media/640_store05-nl-web.136bd1dd.png";